import { Box, Button, HStack } from "@chakra-ui/react";
import { ColorIcon, colors } from "goi_common";

function CompanyInfoBanner({ onClick }: { onClick: () => void }) {
  return (
    <HStack
      background={colors.orange650}
      padding="16px 12px"
      margin="0 0 24px 0"
      alignItems="start"
      width="100%"
      gap={1}
    >
      <ColorIcon
        name="exclamation_point"
        color={colors.white}
        size={20}
        style={{ marginTop: "4px" }}
      />
      <Box className="body_16_m white" width="100%" position={"relative"}>
        잠깐! 장례 비용을 만원 단위까지 알려드는 이곳은
        <br /> <b>투명하고 정직한 장례</b>를 약속하는
        <br />
        <HStack width="100%">
          <div>
            <b>고이장례연구소</b>입니다.
          </div>
          <Box>
            <Button
              style={{
                height: 28,
                position: "absolute",
                right: 0,
                bottom: 0,
                borderRadius: 16,
                backgroundColor: colors.warmGray100,
                padding: "6px 14px",
                boxShadow: "2px 2px 2px #00000022",
              }}
              onClick={onClick}
            >
              <HStack alignItems="center">
                <div className="caption_12_sb black">더 알아보기</div>{" "}
                <ColorIcon name="icon-arrow-right-small-mono" color={colors.black} size={12} />
              </HStack>
            </Button>
          </Box>
        </HStack>
      </Box>
    </HStack>
  );
}

export default CompanyInfoBanner;
